import useImpersonationData from "./useImpersonationData";

const useHasActiveImpersonation = () => {
  const impersonationData = useImpersonationData();

  return !!impersonationData.impersonatedSSN;
};

export default useHasActiveImpersonation;
